import * as types from '../constants/ActionTypes.js'
import * as general from '../constants/General'

const initLayoutState = {
  groupid: 0,
  groups: { items: [] },
  functionbaritems: [],
  functionbartype: general.FUNCTIONBAR_NONE,
  keyboard: { show: false, inputid: null, functionOk: null, functionOkParams: null, message: null, usedispatch: false, input: '' },
  language: { culture: 'nl', current: null, dutch: null, english: null, french: null, german: null, list: [] },
  defaultpage: 0,
  closepage: 0,
  paymentkeygroupid: 0
}

function layouts(state = {
  items: []
}, action) {
  switch (action.type) {
    case types.RECEIVE_LAYOUTS:
      return Object.assign({}, state, {
        items: action.layouts,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

const getLanguageFromAction = (culture, action) => {
  switch (culture) {
    case 'en':
      return action.json.English;
    case 'fr':
      return action.json.French;
    case 'de':
      return action.json.German;
    default:
      return action.json.Dutch;
  }
}

const getLanguageFromState = (culture, state) => {
  switch (culture) {
    case 'en':
      return state.language.english;
    case 'fr':
      return state.language.french;
    case 'de':
      return state.language.german;
    default:
      return state.language.dutch;
  }
}

export const layoutReducer = function start(state = initLayoutState, action) {
  switch (action.type) {
    case types.CLEAR_STATE:
      return initLayoutState;
    case types.SET_LAYOUT:
      return {
        ...state,
        groupid: action.id
      }
    case types.RECEIVE_LAYOUTS:
    case types.REQUEST_LAYOUTS:
      return {
        ...state,
        groups: layouts(state[action.pos], action)
      }
    case types.SET_FUNCTIONBAR_TYPE:
      return {
        ...state,
        functionbartype: action.functionbartype,
        functionbaritems: action.buttons
      }
      case types.CLEAR_KEYBOARD:
        return {
          ...state,
          keyboard: initLayoutState.keyboard
        }
    case types.TOGGLE_KEYBOARD:
      return {
        ...state,
        keyboard: action.data.show ? {
          ...action.data,
        } : {
          ...state.keyboard,
          show: action.data.show
        }
      }
    case types.UPDATE_KEYBOARD_INPUT:
      return {
        ...state,
        keyboard: {
          ...state.keyboard,
          input: action.input
        }
      }
    case types.RECEIVE_LANGUAGES:
      return {
        ...state,
        language: {
          culture: state.language.culture,
          dutch: action.json.Dutch,
          english: action.json.English,
          french: action.json.French,
          german: action.json.German,
          list: action.json.Languages || [],
          current: getLanguageFromAction(state.language.culture, action)
        }
      }
    case types.SET_CULTURE:
      return {
        ...state,
        language: {
          ...state.language,
          culture: action.culture,
          current: getLanguageFromState(action.culture, state)
        }
      }
    case types.SET_DEFAULT_PAGE:
      return {
        ...state,
        defaultpage: action.id
      }
    case types.SET_CLOSE_PAGE:
      return {
        ...state,
        closepage: action.id
      }
    case types.SET_PAYMENT_KEY_KEYLAYOUT_GROUP:
      return {
        ...state,
        paymentkeygroupid: action.json.KeyLayoutGroupId
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/reducers/layout.js